const EXPONDO_BREADCRUMB_NAME = 'expondo';

export {
  EXPONDO_BREADCRUMB_NAME,
};
